var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"shaped":""}},[_c('v-subheader',[_vm._v("MANAGE")]),_c('v-list-item',{attrs:{"exact":"","to":{ name: 'order-books' }}},[_c('v-list-item-title',[_vm._v("Order Books")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }